import React from 'react';
import clsx from 'clsx';
import Connection from '../signalr/connection';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import DashboardIcon from '@material-ui/icons/Dashboard';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import MapIcon from '@material-ui/icons/Map';
import TestLogsIcon from '@material-ui/icons/Description';
import CaseTypesByFipsIcon from '@material-ui/icons/Terrain';
import CaseTypesBySourceIcon from '@material-ui/icons/Fingerprint';
import SymptomAnalysisIcon from '@material-ui/icons/Block';
import FipsWithNoDataIcon from '@material-ui/icons/TrendingDown';
import TrafficIcon from '@material-ui/icons/Traffic';
import CaseCountAnalysisIcon from '@material-ui/icons/FolderOpen';
import DavaValidationIcon from '@material-ui/icons/EventAvailable';
import ArrestsIcon from '@material-ui/icons/AccessibilityNew';
import CriminalIcon from '@material-ui/icons/SportsKabaddi';
import MissingCaseTypesIcon from '@material-ui/icons/Explicit';
import UnservedCaseTrackingRequestsIcon from '@material-ui/icons/Pets';
import GroupWorkIcon from '@material-ui/icons/GroupWorkOutlined';
import UnconfiguredDatabaseIcon from '@material-ui/icons/ErrorOutline';
import UnmodeledSourcesIcon from '@material-ui/icons/HighlightOff';
import ModeledSourcesIcon from '@material-ui/icons/AccountBalanceOutlined';
import MissingDataIcon from '@material-ui/icons/Warning';
import TestDefinitionsIcon from '@material-ui/icons/Book';
import TwoPartSearchIcon from '@material-ui/icons/Filter2';
import HealthStatusIcon from '@material-ui/icons/LocalHospitalOutlined';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    switchWrapper: {
        display: "flex"
    },
    switchLabel: {
        flexGrow: 1,
        paddingTop: 9
    },
    switch: {
        flexShrink:1
    },
    popper: {
        padding: "1em"
    },
    active: {
        backgroundColor: theme.palette.action.selected
    },
    topSection: {
        justifyContent: 'flex-start',
        flexGrow: 1
    },
    bottomSection: {
        display: 'flex',
        alignItems: 'flex-end',
        marginTop: '1em',
        flexDirection: 'column'
    },
    container: {
        display: 'flex',
        flex: '0 0 auto',
        flexDirection: 'column',
        height: '100%',
        flexGrow: 1
    },
    selected: {
        backgroundColor: `rgba(13, 71, 161, .88) !important`,
        color: 'white!important',
        transition: '.5s all ease'
    },
    selectedIcon: {
        color: 'white!important',
        transition: '.5s all ease'
    }
}));


export const MainListItems = () => {
    const classes = useStyles();
    const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
    const notificationPopperOpen = Boolean(notificationAnchorEl);
    const notificationPopperId = notificationPopperOpen ? 'simple-popper' : undefined;
    function showNotificationPopper(event) {
        setNotificationAnchorEl(notificationAnchorEl ? null : event.currentTarget);
    }

    let [selected, setSelected] = React.useState('');


    const [moreNoDataAnchorEl, setMoreNoDataAnchorEl] = React.useState(null);
    const moreNoDataPopperOpen = Boolean(moreNoDataAnchorEl);
    const moreNoDataPopperId = moreNoDataPopperOpen ? 'simple-popper' : undefined;
    function showMoreNoDataPopper(event) {
        setMoreNoDataAnchorEl(moreNoDataAnchorEl ? null : event.currentTarget);
    }

    const [moreCaseTypesAnchorEl, setMoreCaseTypesAnchorEl] = React.useState(null);
    const moreCaseTypesPopperOpen = Boolean(moreCaseTypesAnchorEl);
    const moreCaseTypesPopperId = moreCaseTypesPopperOpen ? 'simple-popper' : undefined;
    function showMoreCaseTypesPopper(event) {
        setMoreCaseTypesAnchorEl(moreCaseTypesAnchorEl ? null : event.currentTarget);
    }

    const [moreTestsAnchorEl, setMoreTestsAnchorEl] = React.useState(null);
    const moreTestsPopperOpen = Boolean(moreTestsAnchorEl);
    const moreTestsPopperId = moreTestsPopperOpen ? 'simple-popper' : undefined;
    function showMoreTestsPopper(event) {
        setMoreTestsAnchorEl(moreTestsAnchorEl ? null : event.currentTarget);
    }


    const [settingsAnchorEl, setSettingsAnchorEl] = React.useState(null);
    const settingsPopperOpen = Boolean(settingsAnchorEl);
    const settingsPopperId = settingsPopperOpen ? 'simple-popper' : undefined;
    function showSettingsPopper(event) {
        setSettingsAnchorEl(settingsAnchorEl ? null : event.currentTarget);
    }

    let onNavigationItemClick = (selectedItem) => () => {
        setSelected(selectedItem);
    }

    const userSettings = JSON.parse(localStorage.getItem('userSettings'));
    const [monitoringConnection, setMonitoringConnection] = React.useState(userSettings['monitoringConnection']);

    let handleMonitoringConnectionChange = (event) => {
        let newValue = event.target.value;
        setMonitoringConnection(newValue);
        var userSettings = JSON.parse(localStorage.getItem('userSettings'));
        userSettings['monitoringConnection'] = newValue;
        localStorage.setItem('userSettings', JSON.stringify(userSettings));
        Connection.then(c => c.invoke("SetUserSettings", userSettings));
    };

    return (
        <div className={clsx(classes.container)}>
            <Popper id={notificationPopperId} open={notificationPopperOpen} anchorEl={notificationAnchorEl} placement="right-end" transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className={classes.popper}>
                            <Typography component="h1" variant="h6" color="inherit" noWrap >Notification Settings</Typography>
                            <Divider />
                            <div className={classes.switchWrapper}>
                                <div className={classes.switchLabel}>New Monitoring Hits</div>
                                <Switch className={classes.switch} />
                            </div>
                            <div className={classes.switchWrapper}>
                                <div className={classes.switchLabel}>Recently Scraped</div>
                                <Switch className={classes.switch} />
                            </div>
                        </Paper>
                    </Fade>
                )}
            </Popper>

            <Popper id={settingsPopperId} open={settingsPopperOpen} anchorEl={settingsAnchorEl} placement="right-end" transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className={classes.popper}>
                            <ListItem button component={Link} to="/fips-with-no-data" className={selected == 'fips-with-no-data' && classes.selected} onClick={onNavigationItemClick('fips-with-no-data')} >
                                <ListItemIcon>
                                    <FipsWithNoDataIcon className={selected == 'fips-with-no-data' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="No Data!" />
                            </ListItem>

                            <ListItem button component={Link} to="/sources-missing-criminal" className={selected == 'sources-missing-criminal' && classes.selected} onClick={onNavigationItemClick('sources-missing-criminal')} >
                                <ListItemIcon>
                                    <CriminalIcon className={selected == 'sources-missing-criminal' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="No Criminal!" />
                            </ListItem>

                            <ListItem button component={Link} to="/sources-missing-traffic" className={selected == 'sources-missing-traffic' && classes.selected} onClick={onNavigationItemClick('sources-missing-traffic')} >
                                <ListItemIcon>
                                    <TrafficIcon className={selected == 'sources-missing-traffic' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="No Traffic!" />
                            </ListItem>
                        </Paper>
                    </Fade>
                )}
            </Popper>
            <Popper id={moreTestsPopperId} open={moreTestsPopperOpen} anchorEl={moreTestsAnchorEl} placement="right-end" transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className={classes.popper}>
                            <ListItem button component={Link} to="/test-definitions" className={selected == 'test-definitions' && classes.selected} onClick={onNavigationItemClick('test-definitions')} >
                                <ListItemIcon>
                                    <TestDefinitionsIcon className={selected == 'test-definitions' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="Test Definitions" />
                            </ListItem>
                            <ListItem button component={Link} to="/test-logs" className={selected == 'test-logs' && classes.selected} onClick={onNavigationItemClick('test-logs')} >
                                <ListItemIcon>
                                    <TestLogsIcon className={selected == 'test-logs' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="Test Logs" />
                            </ListItem>
                        </Paper>
                    </Fade>
                )}
            </Popper>

            <Popper id={moreNoDataPopperId} open={moreNoDataPopperOpen} anchorEl={moreNoDataAnchorEl} placement="right-end" transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className={classes.popper}>
                            <ListItem button component={Link} to="/sources" className={selected == 'sources' && classes.selected} onClick={onNavigationItemClick('sources')} >
                                <ListItemIcon>
                                    <MissingDataIcon className={selected == 'sources' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="Missing Data (CRT_UID)" />
                            </ListItem>

                            <ListItem button component={Link} to="/fips-with-no-data" className={selected == 'fips-with-no-data' && classes.selected} onClick={onNavigationItemClick('fips-with-no-data')} >
                                <ListItemIcon>
                                    <FipsWithNoDataIcon className={selected == 'fips-with-no-data' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="No Data!" />
                            </ListItem>

                            <ListItem button component={Link} to="/sources-missing-criminal" className={selected == 'sources-missing-criminal' && classes.selected} onClick={onNavigationItemClick('sources-missing-criminal')} >
                                <ListItemIcon>
                                    <CriminalIcon className={selected == 'sources-missing-criminal' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="No Criminal!" />
                            </ListItem>

                            <ListItem button component={Link} to="/sources-missing-traffic" className={selected == 'sources-missing-traffic' && classes.selected} onClick={onNavigationItemClick('sources-missing-traffic')} >
                                <ListItemIcon>
                                    <TrafficIcon className={selected == 'sources-missing-traffic' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="No Traffic!" />
                            </ListItem>
                        </Paper>
                    </Fade>
                )}
            </Popper>

            <Popper id={moreCaseTypesPopperId} open={moreCaseTypesPopperOpen} anchorEl={moreCaseTypesAnchorEl} placement="right-end" transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className={classes.popper}>
                            <ListItem button component={Link} to="/sources-missing-case-types" className={selected == 'sources-missing-case-types' && classes.selected} onClick={onNavigationItemClick('sources-missing-case-types')} >
                                <ListItemIcon>
                                    <MissingCaseTypesIcon className={selected == 'sources-missing-case-types' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="Missing Case Types!" />
                            </ListItem>

                            <ListItem button component={Link} to="/source-case-type-info" className={selected == 'source-case-type-info' && classes.selected} onClick={onNavigationItemClick('source-case-type-info')} >
                                <ListItemIcon>
                                    <CaseTypesBySourceIcon className={selected == 'source-case-type-info' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="Case Types By Source" />
                            </ListItem>

                            <ListItem button component={Link} to="/source-case-type-info-by-fips" className={selected == 'source-case-type-info-by-fips' && classes.selected} onClick={onNavigationItemClick('source-case-type-info-by-fips')} >
                                <ListItemIcon>
                                    <CaseTypesByFipsIcon className={selected == 'source-case-type-info-by-fips' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="Case Types By County" />
                            </ListItem>

                            <ListItem button component={Link} to="/missing-case-types" className={selected == 'missing-case-types' && classes.selected} onClick={onNavigationItemClick('missing-case-types')} >
                                <ListItemIcon>
                                    <SymptomAnalysisIcon className={selected == 'missing-case-types' && classes.selectedIcon} />
                                </ListItemIcon>
                                <ListItemText primary="Case Types Unset" />
                            </ListItem>               
                        </Paper>
                    </Fade>
                )}
            </Popper>


            <div className={clsx(classes.topSection)}>

                <ListItem style={{paddingTop: 8}} button component={Link} to={"/"} className={selected == 'dashboard' && classes.selected} onClick={onNavigationItemClick('dashboard')} >
                    <ListItemIcon>
                        <DashboardIcon className={selected == 'dashboard' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>
                

                {/*<ListItem button component={Link} to={"/charts"}  >
                    <ListItemIcon>
                        <ChartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Charts" />
                </ListItem>*/}

                <ListItem button component={Link} to="/map-usa" className={selected == 'map-usa' && classes.selected} onClick={onNavigationItemClick('map-usa')} >
                    <ListItemIcon>
                        <MapIcon className={selected == 'map-usa' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Coverage Maps" />
                </ListItem>

                <ListItem button component={Link} to="/source-health-status" className={selected == 'source-health-status' && classes.selected} onClick={onNavigationItemClick('source-health-status')} >
                    <ListItemIcon>
                        <HealthStatusIcon className={selected == 'source-health-status' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Source Status" />
                </ListItem>

                <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

                <ListItem button component={Link} to="/feature-support" className={selected == 'feature-support' && classes.selected} onClick={onNavigationItemClick('feature-support')} >
                    <ListItemIcon>
                        <GroupWorkIcon className={selected == 'feature-support' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Supported Features" />
                </ListItem>
                <ListItem button component={Link} to="/sources-without-definition-models" className={selected == 'sources-without-definition-models' && classes.selected} onClick={onNavigationItemClick('sources-without-definition-models')} >
                    <ListItemIcon>
                        <UnmodeledSourcesIcon className={selected == 'sources-without-definition-models' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Missing Definitions" />
                </ListItem> 
                <ListItem button component={Link} to="/unconfigured-save-to-db" className={selected == 'unconfigured-save-to-db' && classes.selected} onClick={onNavigationItemClick('unconfigured-save-to-db')} >
                    <ListItemIcon>
                        <UnconfiguredDatabaseIcon className={selected == 'unconfigured-save-to-db' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Database Not Setup" />
                </ListItem>

                <Divider style={{ marginTop: '5px', marginBottom: '5px' }}  />


                {<ListItem button onClick={showMoreNoDataPopper} >
                    <ListItemIcon>
                        <MoreIcon />
                    </ListItemIcon>
                    <ListItemText primary="Missing Data" />
                </ListItem>}

                <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

                <ListItem button component={Link} to="/case-and-charge-counts" className={selected == 'case-and-charge-counts' && classes.selected} onClick={onNavigationItemClick('case-and-charge-counts')} >
                    <ListItemIcon>
                        <CaseCountAnalysisIcon className={selected == 'case-and-charge-counts' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Case/Charge Counts" />
                </ListItem>

                <ListItem button component={Link} to="/data-validation" className={selected == 'data-validation' && classes.selected} onClick={onNavigationItemClick('data-validation')} >
                    <ListItemIcon>
                        <DavaValidationIcon className={selected == 'data-validation' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Data Validation" />
                </ListItem>

                {/*<ListItem button component={Link} to="/charge-counts" className={selected == 'charge-counts' && classes.selected} onClick={onNavigationItemClick('charge-counts')} >
                    <ListItemIcon>
                        <ArrestsIcon className={selected == 'charge-counts' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Charge Count Analysis" />
                </ListItem>
                */}

                <Divider style={{ marginTop: '5px', marginBottom: '5px' }}  />

                {<ListItem button onClick={showMoreCaseTypesPopper} >
                    <ListItemIcon>
                        <MoreIcon />
                    </ListItemIcon>
                    <ListItemText primary="Case Type Analysis" />
                </ListItem>}

                <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

                <ListItem button component={Link} to="/two-part-search-orders" className={selected == 'two-part-search-orders' && classes.selected} onClick={onNavigationItemClick('two-part-search-orders')} >
                    <ListItemIcon>
                        <TwoPartSearchIcon className={selected == 'two-part-search-orders' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Pending 2P-Searches" />
                </ListItem>

                <ListItem button component={Link} to="/unserved-case-trackings" className={selected == 'unserved-case-trackings' && classes.selected} onClick={onNavigationItemClick('unserved-case-trackings')}>
                    <ListItemIcon>
                        <UnservedCaseTrackingRequestsIcon className={selected == 'unserved-case-trackings' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Pending Case Trackings" />
                </ListItem>

                <ListItem button component={Link} to="/missing-expected-results" className={selected == 'missing-expected-results' && classes.selected} onClick={onNavigationItemClick('missing-expected-results')} >
                    <ListItemIcon>
                        <TestLogsIcon className={selected == 'missing-expected-results' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Missing Expected Results" />
                </ListItem>

                <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

                {<ListItem button onClick={showMoreTestsPopper} >
                    <ListItemIcon>
                        <MoreIcon />
                    </ListItemIcon>
                    <ListItemText primary="Tests" />
                </ListItem>}

                {/*<Divider style={{ marginTop: '5px', marginBottom: '5px' }}  />*/}
                {/*<ListItem button component={Link} to="/notifications" className={selected == 'notifications' && classes.selected} onClick={onNavigationItemClick('notifications')} >
                    <ListItemIcon>
                        <NotificationsIcon className={selected == 'notifications' && classes.selectedIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Notification Center" />
                </ListItem>*/}
                
                
            </div>
            
            <div className={clsx(classes.bottomSection)}>
                <ListItem>
                    <TextField
                        id="standard-monitoring-connection-string"
                        select
                        label="Monitoring Connection"
                        className={classes.textField}
                        value={monitoringConnection}
                        onChange={handleMonitoringConnectionChange}
                        SelectProps={{
                            native: true,
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        helperText=""
                        margin="normal"
                    >
                        <option key={1} value={"Monitoring DB"}>
                            Monitoring DB
                                    </option>
                        <option key={2} value={"Monitoring DB [Test]"}>
                            Monitoring DB [Test]
                                    </option>
                        <option key={3} value={"Case Tracking DB [Test]"}>
                            Case Tracking DB [Test]
                                    </option>
                    </TextField>
                </ListItem>
            </div>
        </div>
    )
};

export const SecondaryListItems = () => {
    const classes = useStyles();
    return (
        <div>
            <ListSubheader inset>Saved reports</ListSubheader>
            <ListItem button>
                <ListItemIcon>
                    <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Current month" />
            </ListItem>
            <ListItem button>
                <ListItemIcon>
                    <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Last quarter" />
            </ListItem>
            <ListItem button>
                <ListItemIcon>
                    <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Year-end sale" />
            </ListItem>
        </div>
    )
};
